import { gql } from '@apollo/client';

export const REMOVE_ATTENDEE_FROM_SESSION = gql`
  mutation removeAttendeeFromSession($input: RemoveAttendeeFromSessionInput!) {
    session: removeAttendeeFromSession(input: $input) {
      id
    }
  }
`;
